module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.examination.currentStatus !== 'SUBMITTED') ? _c('div', {
    staticClass: "item__wrapper",
    class: {
      unread: !_vm.examination.read && _vm.examinationCanBeDisplayed
    },
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_c('div', [_vm._v("\n        " + _vm._s(_vm.$t('BRASTER_EXAMINATION_RESULT_FROM')) + "  \n        "), _c('strong', [_vm._v("\n            " + _vm._s(_vm._f("moment")(_vm.examination.isoDate, 'D.MM.YYYY')) + "\n        ")])]), _vm._v(" "), (_vm.examination.additionalData) ? _c('div', {
    staticClass: "examination-id"
  }, [_vm._v("\n        " + _vm._s(_vm.examination.additionalData) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "read-status"
  }, [(_vm.examinationNeedsToComplete) ? _c('span', [_vm._v(_vm._s(_vm.$t('EXAMINATION_NEEDS_DATA')))]) : _vm._e(), _vm._v(" "), (_vm.examinationIsRejected) ? _c('span', [_vm._v(_vm._s(_vm.$t('REJECTED')))]) : (_vm.examinationBrasterInformationReady && _vm.examination.read) ? _c('span', [_vm._v(_vm._s(_vm.$t('READ')))]) : (_vm.examinationBrasterInformationReady && !_vm.examination.read) ? _c('span', [_vm._v(_vm._s(_vm.$t('UNREAD')))]) : (_vm.examinationThermogramsReady) ? _c('span', [_vm._v(_vm._s(_vm.$t('THERMOGRAMS_READY')))]) : (_vm.examinationIsVerifyingAreaLimitations) ? _c('span', [_vm._v(_vm._s(_vm.$t('VERIFYING_AREA_LIMITATIONS')))]) : (!_vm.examinationCanBeDisplayed && !_vm.examinationNeedsToComplete) ? _c('span', [_vm._v(_vm._s(_vm.$t('DOCUMENT_NOT_PUBLISHED')))]) : (!_vm.examination.read && !_vm.examinationNeedsToComplete) ? _c('span', {
    staticClass: "isUnreaded"
  }, [_vm._v(_vm._s(_vm.$t('UNREAD')))]) : (!_vm.examinationNeedsToComplete) ? _c('span', [_vm._v(_vm._s(_vm.$t('READ')))]) : _vm._e()]), _vm._v(" "), _c('div', [_c('span', {
    class: {
      link: true,
      'gray-link': !_vm.examinationCanBeDisplayed
    }
  }, [_vm._v(_vm._s(_vm.$t('SEE')) + " ")]), _vm._v(" "), _c('img', {
    staticClass: "link--img",
    attrs: {
      "src": require("../../../assets/images/arrow-red.png")
    }
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-465fb843","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/medical-results/result-item.vue
// module id = 1190
// module chunks = 0